export default "__VITE_ASSET__21521566__"